import { http } from "../../../shared/api/http"

export type ReportStatus = "pending" | "reviewed" | "resolved" | "dismissed"
export type TargetType = "user" | "course" | "job" | "china"

export type Report = {
  id: string
  reporter_id: string
  target_type: TargetType
  target_id: string
  reason: string
  description: string
  status: ReportStatus
  admin_note: string
  created_at: number
  updated_at: number
}

export type ReportsListResponse = {
  items: Report[]
  total: number
}

export type ReportsFilters = {
  status?: ReportStatus
  target_type?: TargetType
  limit?: number
  offset?: number
}

export const listReportsApi = (filters: ReportsFilters = {}) =>
  http.get<ReportsListResponse>("/api/admin/reports", { params: filters })

export const getReportApi = (reportId: string) =>
  http.get<Report>(`/api/admin/reports/${reportId}`)

export const updateReportStatusApi = (
  reportId: string,
  data: { status: ReportStatus; admin_note?: string }
) => http.patch(`/api/admin/reports/${reportId}/status`, data)

export type ResolveAction = "deactivate" | "dismiss"

export const resolveReportApi = (
  reportId: string,
  data: { action?: ResolveAction; admin_note?: string }
) => http.post<Report>(`/api/admin/reports/${reportId}/resolve`, data)
